import { relayStylePagination } from '@apollo/client/utilities';

const typePolicies = {
  Query: {
    fields: {
      reviews: relayStylePagination(args => {
        const {
          userId,
          listingId,
          categoryId,
          first,
          suburbName,
          region,
          after,
          before,
        } = args;
        if (listingId) {
          return listingId;
        }
        if (userId && first) {
          return `${userId}-${first}`;
        }
        if (userId && after) {
          return `${userId}-${after}`;
        }
        if (categoryId && suburbName) {
          return `${categoryId}-${suburbName}`;
        }
        return (
          userId ||
          listingId ||
          categoryId ||
          suburbName ||
          region ||
          after ||
          before
        );
      }),
      enquiries: relayStylePagination(args => {
        const { userId, first, after, listingId } = args;
        if (listingId) {
          return listingId;
        }
        if (userId && first) {
          return `${userId}-${first}`;
        }
        if (userId && after) {
          return `${userId}-${after}`;
        }
        return userId || after;
      }),
      quotes: relayStylePagination(args => {
        const { userId, first, after, listingId } = args;
        if (listingId) {
          return listingId;
        }
        if (userId && first) {
          return `${userId}-${first}`;
        }
        if (userId && after) {
          return `${userId}-${after}`;
        }
        return userId || after;
      }),
      quoteListings: relayStylePagination(args => {
        const { listingId } = args;
        return listingId;
      }),
      listingPosts: relayStylePagination(args => {
        const keys = ['listingId'];

        const ids = keys.reduce(
          (acc, key) => (args[key] ? [...acc, args[key]] : acc),
          []
        );

        return ids.join('-');
      }),
      favourites: relayStylePagination(),
    },
  },
};

export default typePolicies;
